import { Select } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import { EditContentButtons } from '~/portal/components/ConsumerEditContentButtons'
import { SelectItem } from '~/portal/types/ui.components'

export const ApiViewerToolbar = ({
  testId,
  downloadOptions,
  buildDownloadUrl,
  optionLabelBuilder,
  providerContentSlug,
  shubUrl,
  showEditButtons,
  accentColor,
  downloadDisabled,
}: {
  testId: string
  downloadOptions: SelectItem[]
  buildDownloadUrl?: (format: string) => string | undefined
  optionLabelBuilder?: (option: SelectItem) => string
  providerContentSlug?: string
  shubUrl?: string
  showEditButtons?: boolean
  accentColor?: string
  downloadDisabled?: boolean
}) => {
  const { t } = useTranslation()

  if (!buildDownloadUrl && !showEditButtons) {
    return null
  }

  return (
    <div data-testid={testId} className="sp-api-viewer-toolbar sticky top-0 z-49 flex justify-end w-full gap-1 px-6 md:px-9 xl:px-6 h-20 border-b border-b-(--sp-color-border-subtle) bg-(--sp-color-surface) border-l border-l-[rgba(128,128,128,0.35)]">
      <div className="flex items-center gap-2">
        {buildDownloadUrl ?
          <Select
            size="s"
            aria-label={t('components.ui.apiViewer.downloadApi.ariaLabel')}
            className="!w-[10.625rem] text-body2 leading-none"
            buttonClassName={clsx('sp-api-viewer-download-button border-(--sp-color-border-strong)', !downloadDisabled && 'text-(--sp-color-text-muted)')}
            optionsClassName="sp-api-viewer-download-options !w-[10.625rem] text-body2"
            optionClassName="!whitespace-pre-wrap !break-all"
            theme="neutral"
            defaultValue={{ name: t('components.ui.apiViewer.downloadApi.label'), id: '' }}
            options={downloadOptions}
            onChange={() => {}}
            customOptionBuilder={(option: SelectItem) => (
              <a href={buildDownloadUrl(option.name)}>
                {optionLabelBuilder ? optionLabelBuilder(option) : option.name}
              </a>
            )}
            isStatic={true}
            accentColor={accentColor}
            disabled={downloadDisabled}
          />
          : null
        }
        {showEditButtons ?
          <EditContentButtons contentUrl={providerContentSlug} shubUrl={shubUrl} />
          : null
        }
      </div>
    </div>
  )
}
